const INPUT = "input";
const AUTHENTIFICATION = "authentification";
const AUTHORIZATION = "authorization";
const NOT_FOUND = "notFound";

export default class ErrorToDisplay {
  constructor({ status, data } = {}) {
    if (status === 400) {
      this.type = INPUT;
    } else if (status === 401) {
      this.type = AUTHENTIFICATION;
    } else if (status === 403) {
      this.type = AUTHORIZATION;
    } else if (status == 404) {
      this.type = NOT_FOUND;
    }
    this.errors = [];
    if (this.type == INPUT) {
      for (var prop in data) {
        switch (data[prop][0]) {
          case "Username should be unique":
          case "A user with that username already exists.":
          case "Un utilisateur avec ce nom existe déjà.":
            this.errors.push({
              detail: "alert.usernameAlreadyUsed",
              ref: "usernameInput"
            });
            break;
          case "user with this email address already exists.":
          case "Un objet utilisateur avec ce champ adresse électronique existe déjà.":
            this.errors.push({
              detail: "alert.emailAlreadyUsed",
              ref: "emailInput"
            });
            break;
          case "The url is invalid or we can not reach the url.":
            this.errors.push({
              detail: "alert.cannotReachUrl",
              ref: "websiteUrlInput"
            });
            break;
          case "Ce mot de passe est trop courant.":
            this.errors.push({
              detail: "alert.passwordTooCommun",
              ref: "passwordInput"
            });
            break;
          case "Invalid token for given user.":
            this.errors.push({
              detail: "account.errorMessageAfterResetPasswordAccount",
              ref: "passwordInput"
            });
            break;
        }
      }
    } else if (this.type == AUTHENTIFICATION) {
      this.errors.push({
        detail: "alert.wrongPasswordAndUsernameCombinaison",
        ref: "usernameInput"
      });
    } else if (this.type == AUTHORIZATION) {
      if (data.detail == "Url is not from one of the creator websites") {
        this.errors.push({
          detail: "alert.wrongWebsiteShared",
          ref: "websiteUrlInput"
        });
      }
      if (
        data.detail ==
        "Youtube channel is not from one of the creator Youtube channels"
      ) {
        this.errors.push({
          detail: "alert.wrongYoutubeVideoShared",
          ref: "websiteUrlInput"
        });
      }
    } else if (this.type == NOT_FOUND) {
      if (
        data.detail === "The youtube video has not been found by youtube API"
      ) {
        this.errors.push({
          detail: "alert.noYoutubeVideoFound",
          ref: "websiteUrlInput"
        });
      }
    }
  }
}
